import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/APIEndpoints";
import "../../styles/sidebar.css";
import { useGetProfileQuery } from "../../store/profile/UserApiSlice";
import { useGetUserScoreQuery } from "../../store/caseSimulation/CaseStudyApiSlice";

const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const DashboardIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/dashboard.svg";
const DiagnoseIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/diagnose.svg";
const DoctorsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/doctor.svg";
const ExpertsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/expert.svg";
const PharmacIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/pharmacy.svg";
const ClinicalIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/clinical.svg";
const ClinicalSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/clinicalselected.svg";
const Dashboardselected =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/dashboardselected.svg";
const QBankIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/qbank.svg";
const QBankSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/qbankselected.svg";
const ResearchIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/research.svg";
const ResearchSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/researchselected.svg";
const ExpertSelected =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/expertselected.svg";
const DiagnoseSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/diagnoseselected.svg";
const ImageDXicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/imagedx.svg";
const ImageDXSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/imagedxselected.svg";
const InvestigatoryIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/investigation.svg";
const InvestigatorySelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/investigationselected.svg";
const SymptomsIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/symptom.svg";
const SymptomsSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/symptomselected.svg";
const DoctorSelectedIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/doctorselected.svg";
const arrowdownblack =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/researcharrowblack.svg";
const UserIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";
const DiamondIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/diamond.svg";
const arrowicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/arrow.svg";
const CloseIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/close.svg";
const OpenIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/open.svg";
const CrossIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/cross.svg";
const videos =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/videos.svg";
const power =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/power.svg";
const anti =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/anti.svg";
const target =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/target.svg";
const ProfileIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profile.svg";
export default function PortfolioDropdown({
  selected,
  research,
  isCollapsed,
  onToggle,
}) {
  const navigate = useNavigate();
  const [researchOpen, setResearchOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(selected);
  const [isCollapsedTest, setIsCollapsedTest] = useState(isCollapsed);
  // const [updateprofile, setupdateprofile] = useUpdateProfileMutation();
  const { data: profiledata, isLoading: profileLoading } = useGetProfileQuery();

  useEffect(() => {
    if (research) {
      setResearchOpen(true);
    } else setResearchOpen(false);
  }, [research]);
  const { data, isLoading } = useGetUserScoreQuery();

  const handleNavigation = (item) => {
    setSelectedItem(item);
    setResearchOpen(false);

    if (item === "Portfolio") {
      navigate("/portfolio");
    }
    if (item === "Contact") {
      navigate("/contact");
    }
    if (item === "Feedback") {
      navigate("/feedback");
    }
    if (item === "Pricing") {
      navigate("/pricing");
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleResearchOpen = (item) => {
    if (item !== "Literature" && item !== "Article" && item !== "Report") {
      setSelectedItem("Research");
    } else {
      setSelectedItem(item);
    }
    setResearchOpen(!researchOpen);
  };
  return (
    <div
      className={`sidebar portfoliosidebar ${
        isCollapsed ? "sidebarcollapsed" : "sidebaropen"
      } mobileonly`}
    >
      {!isCollapsed && (
        <div className="closesidebar" onClick={onToggle}>
          <div className="closesidebarbutton">
            <img
              src={isCollapsed ? OpenIcon : CloseIcon}
              alt="Toggle Sidebar"
            />
          </div>
        </div>
      )}
      {!isCollapsed ? (
        <>
          <div className="sidebarheader">
            <img src={Logo} alt="Logo" />
          </div>
          <hr />
        </>
      ) : (
        <>
          <div className="sidebarheader" onClick={onToggle}>
            <div className="closesidebarbutton">
              <img
                src={isCollapsed ? OpenIcon : CloseIcon}
                alt="Toggle Sidebar"
              />
            </div>
          </div>
          <hr />
        </>
      )}

      <div className="sidebarheadermobile">
        <div className="sidebarheadermobileleft">
          {profiledata?.profile ? (
            <>
              <img
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #ccc",
                }}
                onClick={() => handleNavigation("Profile")}
                src={
                  profiledata?.profile?.profile_pic
                    ? `${config.getEndpoint()}${
                        profiledata?.profile?.profile_pic
                      }`
                    : UserIcon
                }
                alt="Reload"
              />
              <h4>
                Welcome Dr. {profiledata?.profile?.first_name.split(" ")[0]}
              </h4>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="sidebarloginbutton"
              >
                Login
              </button>
            </>
          )}
        </div>
        <div className="sidebarheadermobileright">
          <div className="closesidebarbuttonmobile" onClick={onToggle}>
            <img src={CrossIcon} alt="Toggle Sidebar" />
          </div>
        </div>
      </div>

      <div className="sidebarbody">
        <ul>
          {/* <li
            className={
              selectedItem === "Portfolio"
                ? "sidebarelelementselected"
                : "sidebarelement"
            }
            onClick={() => handleNavigation("Portfolio")}
          >
            {!isCollapsed && <p>Portfolio</p>}
          </li> */}
          <li
            className={
              selectedItem === "Contact"
                ? "sidebarelelementselected"
                : "sidebarelement"
            }
            onClick={() => handleNavigation("Contact")}
          >
            {!isCollapsed && <p>Contact Us</p>}
          </li>
          <li
            className={
              selectedItem === "Feedback"
                ? "sidebarelelementselected sidebarcoming"
                : "sidebarelement sidebarcoming"
            }
            onClick={() => handleNavigation("Feedback")}
          >
            <div className="sidebarcomingleft">
              {!isCollapsed && <p>Feedback</p>}
            </div>
          </li>
          <li
            className={
              selectedItem === "Pricing"
                ? "sidebarelelementselected sidebarcoming sidebarhover"
                : "sidebarelement sidebarcoming sidebarhover"
            }
            onClick={() => handleNavigation("Pricing")}
          >
            <div className="sidebarcomingleft">
              {!isCollapsed && <p>Pricing</p>}
            </div>
          </li>
        </ul>
      </div>
      {!isCollapsed ? (
        <div className="sidebarfooter">
          <div className="sidebarfooterleft">
            <img
              src={
                profiledata?.profile?.profile_pic
                  ? `${config.getEndpoint()}${
                      profiledata?.profile?.profile_pic
                    }`
                  : UserIcon
              }
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #ccc",
              }}
              alt="User"
              onClick={() => handleNavigation("Profile")}
            />
            <div className="sidebarfooterchild">
              <h6>
                Dr. {profiledata?.profile?.first_name}{" "}
                {profiledata?.profile?.last_name}
              </h6>
            </div>
          </div>
          <div className="sidebarfooterright">
            {console.log({ profiledata })}
          </div>
        </div>
      ) : (
        <div
          className="sidebarfooter"
          onClick={() => handleNavigation("Profile")}
        >
          <img
            src={
              profiledata?.profile?.profile_pic
                ? `${config.getEndpoint()}${profiledata?.profile?.profile_pic}`
                : UserIcon
            }
            alt="User"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #ccc",
            }}
          />
        </div>
      )}
    </div>
  );
}
